import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useSWRImmutable from 'swr/immutable';

import { StarWinnersApi } from '@/api/cms';
import { fetcherCMS } from '@/modules/api';
import { createCMSQuery, getCMSLocale } from '@/modules/cms';

export const useCMSStarWinners = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const query = useMemo(() => {
    return createCMSQuery({
      populate: ['prime_winners'],
      ...getCMSLocale(language),
    });
  }, [language]);

  const {
    data = null,
    error,
    isLoading,
  } = useSWRImmutable<StarWinnersApi>(
    `/star-winners-block?${query}`,
    fetcherCMS
  );

  return {
    starWinners: data,
    error,
    isLoading,
  };
};
